import React, { useContext, useState } from 'react'
import { BasePopupContext } from '../../../hooks/usePopup';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi from '../../../hooks/useApi';
import { error_alert, success_alert } from '../../../utils';
import { network_tl } from '../../../translations';
import { BiLoaderAlt } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import TextareaField from '../../../components/FormikFields/TextareaField';
import * as yup from "yup";

const StatusChange = ({ refreshListing, data,fromAgency, accept }) => {
  const intl = useIntl()
  const { Axios } = useApi();
  const agency_as_influencer = useSelector(state => state.influencer_profile.active);

  const { closePopup } = useContext(BasePopupContext)

  const initialValues = {
    notes: "",
};

const validationSchema = yup.object({
    notes: yup.string().max(1000, intl.formatMessage({ id: "max_length_1000", defaultMessage: "Max length 1000 characters" })),
});

  const handleSubmit = async (values) => {
    

    let payload = {
      status: accept ? "influencer-accepted" : "influencer-rejected",
      notes: !accept ? values.notes : ""
    }
    try {
      const result = await Axios.patch(`${agency_as_influencer ? `api/influencer/update-status/${data.deliverable.id}/influencer/${agency_as_influencer.id}` : fromAgency ? `api/influencer/update-status/${data.deliverable.id}/influencer/${fromAgency}` : `api/influencer/update-status/${data.deliverable.id}`}`, payload)
      success_alert(result.data.description)
      closePopup()
      refreshListing();

    } catch (e) {
      if (e.response) {
        error_alert(JSON.stringify(e.response.data.description))
      } else {
        error_alert(network_tl(intl))
      }

    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {
        form => (
          <Form>
            <>
              <div className='mb-5'>

                <div className='text-gray-600 mb-5 '>
                  {
                    accept ?
                      <FormattedMessage id="accept_deliverable_desc" defaultMessage={"Are you sure you want to accept this deliverable?"} />
                      :
                      <FormattedMessage id="reject_deliverable_desc" defaultMessage={"Are you sure you want to reject this deliverable?"} />
                  }
                </div>




                {
                  !accept &&
                  <div className='flex-grow'>

                  <TextareaField
                    field="notes"
                    label_text={<FormattedMessage id="note" defaultMessage={"Note"} />}
                    form={form}
                  />

                </div>
                }


              </div>
              <div className='flex w-full justify-end'>
                <button
                  disabled={form.isSubmitting}
                  type='submit'
                  className='btn btn-primary'>
                  {
                    form.isSubmitting ?
                      <BiLoaderAlt className='text-xl mx-auto text-white animate-spin' />
                      :
                      (
                        accept ?
                          <FormattedMessage id="yes_accept" defaultMessage={"Yes, Accept"} />
                          :
                          <FormattedMessage id="yes_reject" defaultMessage={"Yes, Reject"} />
                      )
                  }
                </button>
              </div>




            </>
          </Form>

        )
      }
    </Formik >
  )
}

export default StatusChange